<template>
    <div id='widget-container'>
        <card-form v-if='!!cardMeta'
           ref='refCardForm'
           :meta='cardMeta'
           :use-default-buttons="true"
           :toRemoveToolbarItemsNames="['choice', 'edit', 'delete', 'copy']"
           components-path="views/tep/tep-grid/components"
           :callbacks="{refreshData: refreshWidgetCardData, saveData: saveWidgetCardData, isDirty: null}"
        />
    </div>
</template>
<script>
export default {
    name: 'widget-uzel-ucheta',
}
</script>
<script setup>
import { computed, onMounted, provide, ref, watch } from 'vue';
import { dxUiNotify } from '@/utils/dx-helper';
import getCardMeta from '@/views/tep/tep-grid/store/cards-meta';
import getCardData from '@/views/tep/tep-grid/store/cards-data';
import tepService from '@/service/tep-service';
import tepCardsStore from '@/views/tep/tep-grid/store/tep-cards-store';
import store from '@/views/tep/tep-grid/store/tep-tree-store';
import CardForm from '@/components/card-component/card-form.vue';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
import { useStore } from 'vuex';

const props = defineProps({
    userData: {
        type: Object,
        default: () => {
            return {};
        },
    },
    action: {
        type: Function,
        default: null,
    },
    id: {
        type: String,
    }
});

const emit = defineEmits(['close-popup']);

const refCardForm = ref(null);
const cardMeta = ref(null);
const currentProps = ref(null);
const userDataUU = ref({});

provide('userData', userDataUU);

const isWidgestChangeData = computed(() => {
    return tepCardsStore.state.isChangeWidget;
})

const storeX = useStore();

watch(isWidgestChangeData, async (newValue) => {
    if(newValue === 'isCardChange') {
        await refCardForm.value.onRefreshDataButtonClick();
    }
});

onMounted(async () => {
    currentProps.value = {
        kod_vid: 22200000,
        kod_r: props.userData?.kod_r,
        kod: props.userData?.kod,
        cardName: "Узел учета",
        itemName: props.userData?.name,
        isWidget: true,
    }
    cardMeta.value = await getCardMeta(currentProps.value);
});

const refreshWidgetCardData = async () => {
    tepCardsStore.changeWidget(false);
    const data = await tepService.getCardVidData(currentProps.value.kod, currentProps.value.kod_vid);
    if (!data) { // значит вернулся null
        return await getCardData(currentProps.value);
    }
    return {result: true, data};
}

const saveWidgetCardData = async(data) => {
    const validateRes = validateForm(data);
    if (validateRes !== 'ok') return validateRes;
    if(!tepCardsStore.state.statusSaveButton) {
        tepCardsStore.changeSavegrid(true);
        await tepCardsStore.waitForGridSave();
    }
    const res = await store.updateTreeItem({...data, ...currentProps.value,});
    if (res.result) {
        tepCardsStore.changeWidget('isWidgetChange');
        dxUiNotify('Элемент ТС успешно обновлен', 'success', 3000);
    }
    return res;
}

const validateForm = (data) => {
    if (!data.name || (data.name && data.name.replaceAll(' ', '').length === 0)) {
        return {errors: {message: 'Поле "Наименование" не может быть пустым'}}
    }
    return 'ok';
}

const beforeInstanceClose = async () => {
    const canClose = await refCardForm.value?.isDirtyController();
    if (canClose) {
        const result = await AiCustomConfirmDialog('У вас есть несохраненные изменения, сохранить изменения?');
        if (result === 1) { // нажали "ДА"
            await refCardForm.value?.onSaveDataButtonClick();
        } else if(result === 0) { // нажали "НЕТ"
            await refCardForm.value?.clearUserData();
        } else { // нажали "ОТМЕНА"
            return false;
        }
        await emit('close-popup', 'widget-uzel-ucheta');
        await storeX.commit('deleteOpenedWidget', props.id);
        return;
    }
    await emit('close-popup', 'widget-uzel-ucheta');
}

defineExpose({
    beforeInstanceClose: beforeInstanceClose,
    id: props.id,
});

</script>
<style scoped>

</style>
